export default "__VITE_ASSET__ZXO6aIrs__"